import { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useDebounce } from '$common/react-hooks/use-debounce'
import { SearchInput } from './search-input'

const DebouncingProgressContainer = styled('div')`
  padding: 2px;
  display: flex;
  margin-left: 10px;
`

interface PropTypes {
  disabled?: boolean
  placeholder?: string
  className?: string
  onQueryChange: (text: string) => unknown
}
export function DebouncedUnControlledSearchInput({
  disabled = false,
  placeholder = '',
  className,
  onQueryChange,
}: PropTypes) {
  const [searchQuery, setSearchQuery] = useState<string>('')
  const { debouncedValue: debouncedQuery, isDebouncing } = useDebounce(
    searchQuery,
    300,
  )

  useEffect(() => {
    onQueryChange(debouncedQuery)
  }, [debouncedQuery])

  return (
    <SearchInput
      disabled={disabled}
      query={searchQuery}
      onQueryChange={q => setSearchQuery(q)}
      placeholder={placeholder}
      startAdornment={
        isDebouncing ? (
          <DebouncingProgressContainer>
            <CircularProgress sx={{ color: 'neutral500' }} size="20px" />
          </DebouncingProgressContainer>
        ) : undefined
      }
      className={className}
    />
  )
}
